module.exports = __webpack_public_path__ + "static/media/Group 1319.3f9bf204.svg";